import {ServiceFactory, ServiceData, ServiceContext } from "@/script/core/base/ServiceData";
import { CameraService } from "../service/CameraService";
import { ClientService } from "../service/ClientService";
import { ServerService } from "../service/ServerService";


let serverContext: ServiceContext | null = null;
function createServerContext(): ServiceContext {
    if (serverContext == null) {
        const service = new ServerService();
        serverContext = ServiceFactory.build(
            "biz_dev_server",
            "/device/server",
            "/device/server",
            service
        );
        serverContext.typesName = "dev-server-type";
    }
    return serverContext;
}

let cameraContext: ServiceContext | null = null;
function createCameraContext(): ServiceContext {
    if (cameraContext == null) {
        const service = new CameraService();
        cameraContext = ServiceFactory.build(
            "biz_dev_camera",
            "/device/camera",
            "/device/camera",
            service
        );
        cameraContext.typesName = "dev-camera-type";
    }
    return cameraContext;
}

let clientContext: ServiceContext | null = null;
function createClientContext(): ServiceContext {
    if (clientContext == null) {
        const service = new ClientService();
        clientContext = ServiceFactory.build(
            "biz_dev_client",
            "/device/client",
            "/device/client",
            service
        );
        clientContext.typesName = "dev-client-type";
    }
    return clientContext;
}

export { serverContext, cameraContext, clientContext, createServerContext, createCameraContext, createClientContext };
